module.exports = __webpack_public_path__ + "static/media/home.e8545758.jpg";